import type { RideTrack } from './model';

export type RaceMedal = 'gold' | 'silver' | 'bronze' | 'finisher';
export const trickBonus = (points: number) => Math.min(20, points / 250);
export function raceTime(track: RideTrack, elapsed: number, points: number) { return Math.max(0, elapsed - (track.discipline === 'bmx' ? trickBonus(points) : 0)); }
/** A medal always describes a podium place. Solo rides cannot earn a race medal. */
export function medalFor(position: number, opponents: number): RaceMedal {
  return opponents > 0 && Number.isInteger(position) && position >= 1 && position <= 3 ? (['gold', 'silver', 'bronze'] as const)[position - 1] : 'finisher';
}
/** The legacy catalogue field `medals` now supplies achievement-time thresholds only. */
export function timeStarsFor(track: RideTrack, time: number): number {
  return Number.isFinite(time) && time > 0 ? track.medals.filter(target => time <= target).length : 0;
}
export function paceRatio(track: RideTrack, rawTime: number): number {
  const [fast, steady, finish] = track.paceTargets ?? track.medals;
  const knots = [[fast, 1], [steady, 2/3], [finish, 1/3], [finish * 1.25, 0]];
  if (rawTime <= fast) return 1;
  for (let i = 1; i < knots.length; i++) {
    const [end, value] = knots[i], [start, previous] = knots[i-1];
    if (rawTime <= end) return previous + (value - previous) * (rawTime - start) / (end - start);
  }
  return 0;
}
